module.exports = __webpack_public_path__ + "img/Presentation11.119a808b.png";